import React, { Component } from 'react';

class Header extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var occupation= this.props.data.occupation;
      var description= this.props.data.description;
      var city= this.props.data.address.city;
      
    }

    return (
      <header id="home">

      <nav id="nav-wrap">

         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#about">Team</a></li>
            <li><a className="smoothscroll" href="#portfolio">Works</a></li>
         </ul>

      </nav>

      <div className="row banner">
         <div className="banner-text">

         <img src="/images/logoSapling3.png" alt="HTML5 Icon"></img>
            <h1 className="responsive-headline">Sapling Studios</h1>
            <h3>A small Los Angeles based Indie Game Studio. Founded in 2020. We try to make "fun" games.</h3>
            <hr />
            <ul className="social">

            <a href="https://discord.gg/m9ccjxwd4p" >
               <img src="/images/discord.png" width="45" ></img>
  </a>
  <a href="https://www.youtube.com/channel/UCzMq65F01u2_goDM86b2_CQ" >
               <img src="/images/yt.png" width="45"></img>
  </a>
  <a href="https://twitter.com/SaplingSam" >
               <img src="/images/twitter-xxl.png" width="40"></img>
  </a>
            </ul>
         </div>
      </div>


      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;
